import { useState } from 'react';

import type { TModuleCode } from '@/shared/routes';

import {
  TAB_BAR_DEFAULT_MODULES,
  TAB_BAR_PINNED_MODULES
} from '../../../constants';
import useNavItems, { type INavItem } from '../../../hooks/useNavItems';

/**
 * Пункты таб-бара: закреплённые разделы и третий — последний открытый раздел
 * вне закреплённых (до первого такого перехода — первый доступный из
 * `TAB_BAR_DEFAULT_MODULES`, иначе первый незакреплённый).
 */
const useTabBarItems = (): { items: INavItem[]; activeCode?: TModuleCode } => {
  const { items, activeCode } = useNavItems();
  const [lastExtraCode, setLastExtraCode] = useState<TModuleCode>();

  const isPinned = (code: TModuleCode): boolean =>
    TAB_BAR_PINNED_MODULES.includes(code);

  const pinned = items.filter((item) => isPinned(item.code));
  const extraCandidates = items.filter((item) => !isPinned(item.code));

  // Запоминаем раздел вне закреплённых, как только сотрудник в него перешёл.
  if (activeCode && !isPinned(activeCode) && activeCode !== lastExtraCode) {
    setLastExtraCode(activeCode);
  }

  const extra =
    extraCandidates.find((item) => item.code === lastExtraCode) ??
    extraCandidates.find((item) =>
      TAB_BAR_DEFAULT_MODULES.includes(item.code)
    ) ??
    extraCandidates[0];

  return { items: extra ? [...pinned, extra] : pinned, activeCode };
};

export default useTabBarItems;
